export default {
  files: {
    trainingSheets: [
      {
        key: 'training',
        title: 'Prévention des infections',
        sections: [
          {
            type: 'techSheet',
            links: [
              {
                title: 'Prévention des infections liées à un cathéter',
                icon: 'catheter-prolong',
                link: `documents/tools/SPIADI2022 - PRÉVENTION DES INFECTIONS LIÉES À UN CATHÉTER.pdf`,
                text: 'SPIADI - 27/06/2022',
                description: `SPIADI - OUTILS - PRÉVENTION DES INFECTIONS LIÉES À UN CATHÉTER.pdf`
              },
              {
                title: 'Prévention des infections liées à un CVP',
                icon: 'dropper',
                link: `documents/tools/SPIADI2022 - PRÉVENTION DES INFECTIONS LIÉES À UN CVP.pdf`,
                text: 'SPIADI - 23/06/2022',
                description: `SPIADI - OUTILS - PRÉVENTION DES INFECTIONS LIÉES À UN CVP.pdf`
              }
            ]
          }
        ]
      },
      {
        key: 'rea',
        title: 'Siphons',
        type: 'reaInfADI',
        sections: [
          {
            type: 'reaInfADI',
            links: [
              {
                title: `REX sur la contamination des siphons en réanimation et ailleurs`,
                icon: 'siphon',
                link: `documents/tools/SPIADI2022 - RÉA-SINK.pdf`,
                text: 'SPIADI - 01/07/2022',
                description: `SPIADI - OUTILS - REX RÉA-SINK.pdf`
              }
            ]
          }
        ]
      }
    ],

    techsheets: [
      {
        key: 'insertion',
        title: '<strong>Pose des dispositifs<br> invasifs<strong>',
        sections: [
          {
            title: 'Dispositifs intra-vasculaires',
            type: 'techSheet',
            links: [
              {
                title: `Pose d'un cathéter veineux central ou MIDline avec prolongateur intégré sous échoguidage`,
                icon: 'catheter-prolong',
                link: 'https://l.spiadi.fr/fiche-pose-ktc-2025',
                text: 'SPIADI - 19/11/2025',
                description: `SPIADI - OUTILS - POSE D'UN CATHÉTER VEINEUX CENTRAL OU MIDLINE AVEC PROLONGATEUR INTÉGRÉ SOUS ÉCHOGUIDAGE.pdf`
              },
              {
                title: `Pose d'un cathéter veineux central ou MIDline avec prolongateur intégré sous échoguidage (avec aide)`,
                icon: 'catheter-prolong',
                link: 'https://l.spiadi.fr/fiche-pose-ktc-aide-2025',
                text: 'SPIADI - 19/11/2025',
                description: `SPIADI - OUTILS - POSE D'UN CATHÉTER VEINEUX CENTRAL OU MIDLINE AVEC PROLONGATEUR INTÉGRÉ SOUS ÉCHOGUIDAGE (AVEC AIDE).pdf`
              },
              {
                title: `Pose d'une CCI`,
                icon: 'chamber',
                link: 'https://l.spiadi.fr/2017-cpias-fiche-tech-pose-cci',
                text: 'CPias Centre-Val de Loire - 2017',
                description: `SPIADI - OUTILS - POSE D'UNE CCI.pdf`
              },
              {
                title: `Pose d'un CVP ou d'un MIDline sans prolongateur intégré`,
                icon: 'dropper',
                link: 'https://l.spiadi.fr/fiche-pose-cvp-mid-spi-2025',
                text: 'SPIADI - 19/11/2025',
                description: `SPIADI - OUTILS - POSE D'UN CVP OU D'UN MIDLINE SANS PROLONGATEUR INTÉGRÉ.pdf`
              }
            ]
          },
          {
            title: 'Nouveau-né',
            type: 'neoInfADI',
            links: [
              {
                title: `Pose d'un cathéter veineux central pour la nutrition parentérale en néonatalogie`,
                icon: `catheter-prolong`,
                link: `documents/tools/SPIADI2022 - POSE D'UN CVC EN NEONATALOGIE - V2.pdf`,
                text: 'SPIADI - 21/11/2022',
                description: `SPIADI - OUTILS - POSE D'UN CVC EN NEONATOLOGIE.pdf`
              }
            ]
          },
          {
            title: 'Dispositifs urinaires',
            type: 'observa4',
            links: [
              {
                title: `Pose d’une sonde vésicale à demeure/sondage évacuateur`,
                icon: `catheter-uri`,
                link: `https://l.spiadi.fr/cpias-fiche-tech-pose-sonde-vesicale-2026`,
                text: 'CPias Centre-Val de Loire - 2026',
                description: `SPIADI - OUTILS - POSE D'UNE SONDE VESICALE À DEMEURE / SONDAGE ÉVACUATEUR.pdf`
              }
            ]
          }
        ]
      },
      {
        key: 'handling',
        title: `<strong>
                  Manipulations des dispositifs<br> intra-vasculaires et<br>
                  gestion des lignes
                </strong>`,
        sections: [
          {
            type: 'techSheet',

            links: [
              {
                title: `Pose et dépose d'aiguille sur CCI`,
                icon: 'chamber',
                type: 'techSheet',
                link: 'https://l.spiadi.fr/fiche-pose-depose-aiguille-cci',
                text: 'SPIADI - 19/11/2025',
                description: `SPIADI - OUTILS - POSE ET DÉPOSE D'AIGUILLE SUR CCI.pdf`
              },
              {
                title: `Manipulations et gestion des lignes pour les CVC, PICCline, CCI et MIDline avec prolongateur intégré`,
                icon: 'notebook',
                type: 'techSheet',
                link: 'https://l.spiadi.fr/2020-cpias-fiche-tech-gestion-lignes',
                text: 'CPias Centre-Val de Loire - 30/12/2020',
                description: `SPIADI - OUTILS - MANIPULATIONS ET GESTION DES LIGNES POUR LES CVC, PICCLINE, CCI ET MIDLINE AVEC PROLONGATEUR INTÉGRÉ.pdf`
              },
              {
                title: `Réfection d'un pansement de CVC, PICCline, CCI ou Midline avec prolongateur intégré`,
                icon: 'plaster',
                type: 'techSheet',
                link: 'https://l.spiadi.fr/fiche-refection-pansement-cvc-picc-mid-pi',
                text: 'SPIADI - 19/11/2025',
                description: `SPIADI - OUTILS - RÉFECTION D'UN PANSEMENT DE CVC, PICCLINE, CCI OU MIDLINE AVEC PROLONGATEUR INTÉGRÉ.pdf`
              },
              {
                title: `Réfection du pansement de l’émergence d’un cathéter de Dialyse`,
                icon: 'plaster',
                type: 'techSheet',
                link: 'https://www.cpias-centre.fr/wp-content/uploads/2025/02/2025-SPIADI-FICHE-TECH-REF-PANSEMENT-DIALYSE.pdf',
                text: 'CPias Centre-Val de Loire - 06/02/2025',
                description: `SPIADI - OUTILS - RÉFECTION DU PANSEMENT DE L'ÉMERGENCE D'UN CATHÉTER DE DIALYSE.pdf`
              },
              {
                title: `Retrait d'un CVC, PICCline ou d'un MIDline avec prolongateur intégré`,
                icon: 'catheter-prolong',
                type: 'techSheet',
                link: 'https://l.spiadi.fr/2020-cpias-fiche-tech-retrait-cvc-picc-mid-api',
                text: 'CPias Centre-Val de Loire - 30/12/2020',
                description: `SPIADI - OUTILS - RETRAIT D'UN CVC, PICCLINE OU D'UN MIDLINE AVEC PROLONGATEUR INTÉGRÉ.pdf`
              },
              {
                title: `Manipulations, gestion des lignes et retrait des CVP et MIDline sans prolongateur intégré`,
                icon: 'dropper',
                type: 'techSheet',
                link: 'https://l.spiadi.fr/2020-cpias-fiche-tech-gestion-retrait-cvp',
                text: 'CPias Centre-Val de Loire - 30/12/2020',
                description: `SPIADI - OUTILS - MANIPULATIONS, GESTION DES LIGNES ET RETRAIT DES CVP ET MIDLINE SANS PROLONGATEUR INTÉGRÉ.pdf`
              },
              {
                title: `PICCline et MIDline en secteur hospitalier`,
                icon: 'dropper',
                type: 'techSheet',
                link: 'https://l.spiadi.fr/cpias_pdl_piccline_sechopital',
                text: 'CPias Pays de la Loire - 03/06/2026',
                description: `SPIADI - OUTILS - PICCLINE ET MIDLINE EN SECTEUR HOSPITALIER.pdf`
              },
              {
                title: `PICCline et MIDline en libéral`,
                icon: 'catheter-prolong',
                type: 'techSheet',
                link: 'https://l.spiadi.fr/cpias_pdl_piccline_secliberal',
                text: 'CPias Pays de la Loire - 03/06/2026',
                description: `SPIADI - OUTILS - PICCLINE ET MIDLINE EN LIBÉRAL`
              },
              {
                title: `Les points fondamentaux du bon usage du cathéter à chambre implantable (CCI) en soins à domicile`,
                icon: 'chamber',
                type: 'techSheet',
                link: 'https://l.spiadi.fr/cpias_pdl_cci_domicile',
                text: 'CPias Pays de la Loire - 03/06/2026',
                description: `SPIADI - OUTILS - BON USAGE CCI AU DOMICILE`
              },
              {
                title: `Surveillance de la voie veineuse périphérique (échelle de Maddox)`,
                icon: 'dropper',
                type: 'techSheet',
                link: 'https://l.spiadi.fr/cpias_maddox_v5',
                text: 'CPias Pays de la Loire - 20/02/2024',
                description: 'SPIADI - OUTILS - SURVEILLANCE DE LA VOIE VEINEUSE PÉRIPHÉRIQUE.pdf'
              }
            ]
          },
          {
            title: 'Nouveau-né',
            type: 'neoInfADI',
            links: [
              {
                title: `Gestion, manipulations et retrait d'un cathéter veineux central pour la nutrition parentérale en néonatalogie`,
                icon: `catheter-prolong`,
                type: 'neoInfADI',
                link: 'https://l.spiadi.fr/fiche-gestion-manipulations-retrait-cvc-neonat',
                text: 'SPIADI - 19/11/2025',
                description: 'SPADI - GESTION MANIPULATIONS RETRAIT CVC EN NEONATOLOGIE.pdf'
              }
            ]
          }
        ]
      },
      {
        key: 'antisepticsUsage',
        title: '<strong>Utilisation des antiseptiques</strong>',
        sections: [
          {
            title: 'Adulte',
            type: 'techSheet',
            links: [
              {
                title: `Choix des antiseptiques et actes invasifs chez l'adulte`,
                icon: 'antiseptic',
                type: 'techSheet',
                link: 'https://www.cpias-centre.fr/wp-content/uploads/2022/12/2024-CPIAS-FICHE-TECH-CHOIX-ASQ-V4.pdf',
                text: 'CPias Centre-Val de Loire - 06/02/2025',
                description: `SPIADI - OUTILS - CHOIX DES ANTISEPTIQUES ET ACTES INVASIFS CHEZ L'ADULTE.pdf`
              }
            ]
          }
        ]
      }
    ]
  }
}
